document.addEventListener('DOMContentLoaded', function () {
  var STORAGE_KEY = 'fac_a11y_prefs';
  var TEXT_STEPS = ['100', '110', '125', '150'];
  var TOGGLE_KEYS = ['spacing', 'lineHeight', 'readableFont', 'links', 'cursor', 'guide', 'contrast', 'invert', 'grayscale', 'motion', 'hideImages'];
  var CLASS_MAP = {
    spacing: 'a11y-wide-spacing',
    lineHeight: 'a11y-tall-lines',
    readableFont: 'a11y-readable-font',
    links: 'a11y-underline-links',
    cursor: 'a11y-big-cursor',
    guide: 'a11y-reading-guide-active',
    contrast: 'a11y-high-contrast',
    motion: 'a11y-reduce-motion',
    hideImages: 'a11y-hide-images'
  };

  var widget = document.querySelector('[data-a11y-widget]');
  if (!widget) return;

  var toggle = widget.querySelector('[data-a11y-toggle]');
  var panel = widget.querySelector('[data-a11y-panel]');
  var closeBtn = widget.querySelector('[data-a11y-close]');
  var resetBtn = widget.querySelector('[data-a11y-reset]');
  var decreaseBtn = widget.querySelector('[data-a11y-text-decrease]');
  var increaseBtn = widget.querySelector('[data-a11y-text-increase]');
  var cards = widget.querySelectorAll('[data-a11y-card]');

  function defaultPrefs() {
    var prefs = { textStep: 0 };
    TOGGLE_KEYS.forEach(function (key) { prefs[key] = false; });
    return prefs;
  }

  function readPrefs() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function writePrefs() {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch (e) {
      /* storage unavailable, fail quietly */
    }
  }

  var prefs = Object.assign(defaultPrefs(), readPrefs());

  /* ---------- Reading guide ---------- */
  var readingGuideEl;
  function ensureReadingGuide() {
    if (!readingGuideEl) {
      readingGuideEl = document.createElement('div');
      readingGuideEl.className = 'a11y-reading-guide-bar';
      readingGuideEl.setAttribute('aria-hidden', 'true');
      document.body.appendChild(readingGuideEl);
    }
    return readingGuideEl;
  }
  function onGuideMove(e) {
    ensureReadingGuide().style.top = (e.clientY - 18) + 'px';
  }
  function setReadingGuide(active) {
    if (active) {
      ensureReadingGuide().style.display = 'block';
      document.addEventListener('mousemove', onGuideMove);
    } else {
      document.removeEventListener('mousemove', onGuideMove);
      if (readingGuideEl) readingGuideEl.style.display = 'none';
    }
  }

  function applyPrefs() {
    document.documentElement.style.zoom = TEXT_STEPS[prefs.textStep] + '%';

    TOGGLE_KEYS.forEach(function (key) {
      if (key === 'invert' || key === 'grayscale' || key === 'guide') return;
      document.documentElement.classList.toggle(CLASS_MAP[key], !!prefs[key]);
    });

    var filters = [];
    if (prefs.grayscale) filters.push('grayscale(100%)');
    if (prefs.invert) filters.push('invert(100%) hue-rotate(180deg)');
    document.documentElement.style.filter = filters.join(' ');

    setReadingGuide(!!prefs.guide);

    cards.forEach(function (card) {
      var key = card.getAttribute('data-a11y-key');
      var active = !!prefs[key];
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-pressed', String(active));
    });
  }

  applyPrefs();

  function openPanel() {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
  }

  function closePanel() {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', function () {
    if (panel.hidden) openPanel(); else closePanel();
  });

  closeBtn.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) closePanel();
  });

  document.addEventListener('click', function (e) {
    if (!panel.hidden && !widget.contains(e.target)) closePanel();
  });

  decreaseBtn.addEventListener('click', function () {
    prefs.textStep = Math.max(0, prefs.textStep - 1);
    writePrefs();
    applyPrefs();
  });

  increaseBtn.addEventListener('click', function () {
    prefs.textStep = Math.min(TEXT_STEPS.length - 1, prefs.textStep + 1);
    writePrefs();
    applyPrefs();
  });

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      var key = card.getAttribute('data-a11y-key');
      prefs[key] = !prefs[key];
      writePrefs();
      applyPrefs();
    });
  });

  resetBtn.addEventListener('click', function () {
    prefs = defaultPrefs();
    writePrefs();
    applyPrefs();
  });
});
